import type { MantineColor, StyleProp } from '@mantine/core'
import { Paper, Text } from '@mantine/core'
import styles from './OrderMetaInfoVehicle.module.css'

interface OrderMetaInfoProps {
  vanNumber?: string | string[]
  sequenceNumber?: string | string[]
  bg?: StyleProp<MantineColor>
  size?: 'sm' | 'md' | 'lg'
}

export function OrderMetaInfoVehicle({
  vanNumber,
  sequenceNumber,
  bg,
  size = 'md',
}: OrderMetaInfoProps) {
  const sizeClass
    = size === 'sm' ? styles.sizeSm : size === 'lg' ? styles.sizeLg : styles.sizeMd
  return (
    <Paper bg={bg} className={`${styles.infoCard} ${sizeClass}`}>
      {vanNumber && (
        <div className={styles.infoItem}>
          <Text span className={styles.vehicleLabel}>
            Van
          </Text>
          <Text span className={styles.vehicleValue}>
            {vanNumber}
          </Text>
        </div>
      )}

      {sequenceNumber && (
        <div className={styles.infoItem}>
          <Text span className={styles.vehicleLabel}>
            Seq
          </Text>
          <Text span className={styles.vehicleValue}>
            {sequenceNumber}
          </Text>
        </div>
      )}
    </Paper>
  )
}
